import { Box } from '@mui/material';
import React, { FC } from 'react';
import InboxResults from './Results';
import InboxFilters from './Controls';
const InboxContent: FC = () => {
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <InboxFilters />
      <InboxResults />
    </Box>
  );
};

export default InboxContent;
